import React, { FC, useRef } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { Controller, Control, FieldErrors } from 'react-hook-form'
import Select from 'react-select'

import { CustomStyles } from './styles'

interface IProps {
  name: string;
  placeholder?: string;
  control: Control<any>;
  options: Option[];
  errors?: FieldErrors<any>;
  isSearchable?: boolean
  disabled?: boolean,
}

interface Option {
  value: string;
  label: string;
}

export const CustomSelect: FC<IProps> = (
  {
    name,
    control,
    options,
    placeholder,
    isSearchable = false,
    errors,
    disabled
  }) => {

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => {
        const { onChange, value } = field
        const handleChange = (selectedOption: Option | null) => {
          const selectedValue = selectedOption ? selectedOption.value : ''
          onChange(selectedValue)
        }

        const currentSelectedValue = options.find((option) => option.value === value) || null

        return (
          <Select
            {...field}
            isDisabled={disabled}
            id={name}
            options={options}
            value={currentSelectedValue}
            isSearchable={isSearchable}
            form="autoComplete:off"
            // components={{
            //   IndicatorSeparator: () => null,
            //   DropdownIndicator,
            //   Option: IconOption
            // }}
            onChange={handleChange}
            placeholder={placeholder}
            styles={CustomStyles(Boolean(errors && errors[name]))}
          />
        )
      }}
    />
  )
}
// import Select, { components } from "react-select";
//
// const options = [
//   { value: "England", label: "England", icon: "england.svg" },
//   { value: "Germany", label: "Germany", icon: "germany.svg" }
// ];
//
// const { Option } = components;

// const IconOption = props => (
//   <Option {...props}>
//     <img
//       src={require('./' + props.data.icon)}
//       style={{ width: 36 }}
//       alt={props.data.label}
//     />
//     {props.data.label}
//   </Option>
// );
